import React from 'react';

const SiteStateContext = React.createContext();
export default SiteStateContext;
